import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseContactRoute } from "@/lib/data/requests/contacts/contact";
import type { APIResponse } from "@/lib/types";

export type SignatureRequestTemplateData = {
  document_name: string;
  document_id: string;
  due_date: string;
  unique_password: string;
  signature_link: string;
  expiration_date: string;
  sender_name: string;
  firm_name: string;
  recipient_name: string;
};

export type ShareFolderTemplateData = {
  share_folder_label: string;
  share_folder_passcode: string;
  share_folder_link: string;
  expiration_date: string;
  sender_name: string;
  firm_name: string;
  recipient_name: string;
  subject: string;
  preheader: string;
};

export interface SendTemplatedEmailPayload {
  toEmails: string[];
  templateName: string;
  templateData: SignatureRequestTemplateData | ShareFolderTemplateData;
  contactIds: string[];
  ccEmails?: string[];
  bccEmails?: string[];
  fromEmail?: string;
}

export interface SendTemplatedEmailToUserPayload {
  userIds: string[];
  toEmails: string[];
  templateName: string;
  templateData: SignatureRequestTemplateData;
}

export function sendTemplatedEmailV1(data: SendTemplatedEmailPayload) {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<unknown>
    >(`${baseContactRoute}/communications/emails/send`, data)
    .then((res) => res.data);
}

export function sendTemplatedEmailToUserV2(
  data: SendTemplatedEmailToUserPayload,
) {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<unknown>
    >("firms/v2/communications/emails/send-user", data)
    .then((res) => res.data);
}
